module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row input-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("\n        Name: "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "A descriptive name like: Nade from A to Mid"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        Type: "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleTypeChange
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n            " + _vm._s(type.name) + "\n          ")])
  }))]), _vm._v(" "), _c('div', [_vm._v("\n        Usage: "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleUsageChange
    }
  }, _vm._l((_vm.usages), function(usage) {
    return _c('option', {
      domProps: {
        "value": usage
      }
    }, [_vm._v("\n            " + _vm._s(usage) + "\n          ")])
  }))]), _vm._v(" "), _c('div', [_vm._v("\n        Description: "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "placeholder": "Where do we need to look? When do we need to throw? Do we need to run and jump?"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 center-xs"
  }, [_c('div', {
    staticClass: "box map-container"
  }, [_c('span', [_vm._v("\n        Draw a line by clicking on the map\n      ")]), _vm._v(" "), (_vm.minimap) ? _c('nade-map', {
    attrs: {
      "name": _vm.$route.params.map,
      "minimap": _vm.minimap,
      "entries": _vm.entry.type && [_vm.entry],
      "draggable": false
    },
    on: {
      "click": _vm.handleMapClick,
      "rightclick": _vm.handleMapRightClick
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reset-button-container"
  }, [_c('a', {
    staticClass: "reset-button",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleMapRightClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-loop-strong"
  }), _vm._v("\n          Reset\n        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 center-xs"
  }, [_c('div', {
    staticClass: "next-button-container"
  }, [(_vm.$v.$invalid) ? _c('a', {
    staticClass: "disabled-button"
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v("\n        Enter the required fields\n      ")]) : _c('router-link', {
    staticClass: "next-button",
    attrs: {
      "to": {
        name: 'DashboardAddContent',
        params: {
          name: this.name,
          description: this.description,
          locations: this.locations,
          type: this.type || this.types[0].id,
          usage: this.usage || this.usages[0]
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-checkmark"
  }), _vm._v("\n        Next step\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n      Add a new nade\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190a413e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/Add/Details/index.vue
// module id = 707
// module chunks = 1